import {
  initializeScoringState,
  normalizeScores,
  runScoringPipeline,
} from "./pipeline";

import type { TypeaheadCache } from "@mirage/service-typeahead-search/service/typeahead-cache";
import type { typeahead } from "../../types";

/**
 * Main scoring function that runs the modular scoring pipeline
 */
export function score(
  query: string,
  mode: string,
  sourceResults: typeahead.ScoredResult[],
  callableSections: typeahead.PredicateSubject<typeahead.SectionId>[],
  cache: TypeaheadCache,
  config: typeahead.Config,
): Promise<Record<typeahead.SectionId, number>> {
  const initialState = initializeScoringState(
    query,
    mode,
    sourceResults,
    callableSections,
    cache,
    config,
  );

  return runScoringPipeline(initialState, [
    // applyBaseHybridScoring,
    // applyPersonalization,
    normalizeScores,
  ]);
}
